var BackInStock = function(variantId, productId){
	var obj = this;
	this.VariantId = variantId;
	this.ProductId = productId;

	var bisEmbedWrapper = $('.back-in-stock-wrapper');
	var responseWrapper = $('.back-in-stock-response-wrapper', bisEmbedWrapper);

	var notificationCallback = function(data) {
		var msg = '', isError = false;
		if (data.status == 'OK'){
		  msg = data.message;
		}else{
		  for (var k in data.errors){
			msg += data.errors[k].join();
		   }
		   isError = true;
		}
		responseWrapper.html('');
		responseWrapper.append(isError ? '<span class="BIS_response text-center back-in-stock-error"><span class="error">'+msg+'</span></span>' : '<span class="BIS_response text-center back-in-stock-success"><span class="ok">'+msg+' </span>');
	};

	$('.notify-me', bisEmbedWrapper).click(function(e){
		e.preventDefault();
		var emailField = $('.back-in-stock-email', bisEmbedWrapper)
		var email = emailField.val();
		if(email != ""){
			console.log('Sending values', obj.VariantId, obj.ProductId);
			var newsletterSignup = $('#backinstock-newsletter-signup', bisEmbedWrapper).is(':checked');
			if(!newsletterSignup){
				BISPopover.create(email, obj.VariantId, obj.ProductId).then(notificationCallback);
			}else{
				BISPopover.create(email, obj.VariantId, obj.ProductId, { accepts_marketing: true }).then(notificationCallback);
			}
		}else{
			emailField.focus();
		}
	});

	$('input', bisEmbedWrapper).keypress(function (e) {
	    if(e.which == 13) {
	        $('.notify-me', bisEmbedWrapper).trigger('click');
	    }
	});
};
